import * as React from 'react';
import b_ from 'b_';
import { useState } from 'react';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import Modal from 'shared/components/Modal';
import { getContent } from '../content';

import './index.scss';

import * as decorator from './static/img/decorator-small.svg';

interface Props {
  active: number;
  onClose: () => void;
  tabIndex: number;
}

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('main-page-results-popup');

const context = require.context('./static/icons');

interface Image {
  src: string;
  srcSet: string;
  sizes: string[];
}

type Images = { [key: string]: Image };

const images: Images = context.keys().reduce((result: Images, filename) => {
  const path = context(filename);
  const [, base] = filename.match(/^\.\/([^.@]+)/)!;
  const size = filename.match(/@(.+)\./);

  result[base] = result[base] || { sizes: [] };

  if (!size) {
    result[base].src = path;
  } else {
    result[base].sizes.push(`${path} ${size[1]}`);
  }
  return result;
}, {});

Object.keys(images).forEach((base) => {
  images[base].srcSet = images[base].sizes.join(', ');
});

const MAX_WIDTH = 452;

const barSize = (value: number) =>
  Math.abs(value) * 3 > MAX_WIDTH ? ` 100%` : ` ${Math.abs(value) * 3}px`;

const Popup: React.FC<Enhanced> = ({ t, active, onClose, tabIndex }) => {
  const [isActive, setIsActive] = useState(active || 0);

  const content = getContent(t)[tabIndex];

  const onTabClick = (i: number) => {
    setIsActive(i);
  };

  return (
    <div className={b()}>
      <Modal onClose={onClose}>
        <div className={b('tab-list')}>
          <div className={b('tab-list-inner')}>
            {content.popup &&
              content.popup.map((item, i) => (
                <div
                  key={i}
                  className={b('tab', { selected: i === isActive })}
                  onClick={() => onTabClick(i)}
                >
                  {item.title}
                </div>
              ))}
          </div>
          <div className={b('text')}>{content.popupText}</div>
        </div>
        <div className={b('content-list')}>
          {content.popup &&
            content.popup[isActive].subitems.map((item, i) => (
              <React.Fragment key={i}>
                <div className={b('name')}>
                  <div className={b('icon-wrap')}>
                    <img
                      src={images[item.title.replace(/\s/g, '_')].src}
                      alt="icon"
                      style={{ height: item.height }}
                    />
                  </div>
                  <span title={item.title} className={b('name-company')}>
                    {item.title}
                  </span>
                </div>
                <div className={b('row')}>
                  <div className={b('bar-wrapper')}>
                    <div
                      className={b('bar-text', { loss: item.value < 0, profit: item.value >= 0 })}
                    >
                      {item.value > 0 ? '+' : ''}
                      {item.value}%
                    </div>
                    <div
                      className={b('bar', { loss: item.value < 0, profit: item.value >= 0 })}
                      style={{ width: barSize(item.value) }}
                    >
                      {item.value * 3 >= MAX_WIDTH && (
                        <img className={b('bar-decorator')} src={decorator} alt="" />
                      )}
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ))}
        </div>
      </Modal>
    </div>
  );
};

export default translate(Popup);
